import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { MyClientsCriteria } from '../../models/my-clients-criteria'
import * as _ from 'lodash'
import { ReportsGateway } from '../../gatewasys/reports.gateway'
import { KeyValue } from '../../models/KeyValue'
import { EnrollmentReportDetailsModel } from '../../models/enrollment-report-details.model'
import { PortalGlobals } from '../../../portalglobals'

@Component({
    selector: 'EnrollmentDetailsReport',
    templateUrl: 'enrollment-details-report.component.html'
})
export class EnrollmentDetailsReportComponent implements OnInit {
    myClientsCriteria: MyClientsCriteria
    details: KeyValue[] = [] as KeyValue[]
    summaryDetail: EnrollmentReportDetailsModel
    wesLastAccessDate: string
    public loading = false
    constructor(private _reportsGateway: ReportsGateway, private _routers: Router, private _globals: PortalGlobals) {}

    ngOnInit() {
        ;(<HTMLElement>document.getElementsByClassName('search-criteria')[0]).style.display = 'none'
        this.loading = true
        this.myClientsCriteria = this._reportsGateway.myClientsCriteria
        this.myClientsCriteria = JSON.parse(localStorage.getItem('summaryCriteria')!)

        this._reportsGateway.getEnrollmentReportDetails(this.myClientsCriteria).subscribe(
            (data) => {
                if (data !== null) {
                    this.summaryDetail = data
                    for (let x in this.summaryDetail) {
                        let row = new KeyValue()
                        row.key = x.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1')
                        if (row.key.trim() === 'HICN') {
                            row.key = row.key.replace('HICN', 'Medicare Number')
                        }
                        row.value = this.summaryDetail[x] === null || this.summaryDetail[x] === '0001-01-01T00:00:00' ? '' : this.summaryDetail[x]
                        this.details.push(row)
                    }
                }
                this.loading = false
            },
            (error) => {
                this.loading = false
            }
        )
        this._reportsGateway.getWESLastAccess().subscribe((date) => {
            this.wesLastAccessDate = date
        })
    }
    onBack() {
        const insCo = this._globals.currentUser.insuranceCompanyShortName.toLowerCase()
        this._routers.navigateByUrl('/' + insCo + '/reports/my-clients/summary')
    }
    /*
    onPrint() {
               
        Array.from(document.getElementsByClassName("do-not-print")).forEach(function (item) {
            (<HTMLElement>item).style.display = 'none';
        });
        (<HTMLElement>document.getElementsByClassName("content")[0]).style.display = 'none';
        window.print();
        Array.from(document.getElementsByClassName("content")).forEach(function (item) {
           
                (<HTMLElement>item).style.display = 'block';
        });
        Array.from(document.getElementsByClassName("do-not-print")).forEach(function (item) {
            (<HTMLElement>item).style.display = 'block';
        });
        (<HTMLElement>document.getElementsByClassName("content")[0]).style.display = 'block';
		(<HTMLElement>document.getElementsByClassName("search-criteria")[0]).style.display = 'none';
    }
    */
    printPDF(): void {
        let printContents, popupWin, insCoLogo

        printContents = document.getElementById('printable')?.innerHTML
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto')
        popupWin.document.open()
        popupWin.document.write(`
        <html>
            <head>
              <title></title>
              <style>
                table {
                    border-top: 1px solid #8c8c8c;
                    border-right: 1px solid #000;
                    border-bottom: 1px solid #8c8c8c;
                    border-left: 1px solid #000;
                    font-family: Helvetica, Arial, sans-serif;
                }
                table thead {
                    background-color: #e9e9e9;
                }
                 table th {
                    text-align: left;
                    padding: 14px 24px;
                    border-right: 1px solid #000;
                    border-bottom: 1px solid #8c8c8c;
                }
                table td {
                    padding: 16px 24px;
                    border-right: 1px solid #000;
                    border-bottom: 1px solid #8c8c8c;
                } 
                table th:last-child {
                    border-right: none;
                }
                table td:last-child {
                    border-right: none;
                }  
                table tr:last-child td {
                    border-bottom: none;
                }      
              </style>
            </head>
            <body onload="window.print();window.close()">
        ${printContents}
        </body>
              </html>`)

        popupWin.document.close()
        window.close()
    }
}
